{
  "logout": "Logout",
  "logoutHeader": "Logout",
  "logoutQuestion": "Are you sure you want to log out?",
  "theme": "Theme Style",
  "accMgmt": "Account Management",
  "reload": "Reload",
  "language": "語言",
  "idleHint": "Idle countdown; auto logout at zero"
}